import axios from 'axios';
import APIConfig from 'config/api';

import { EVENT } from 'constants/event';
import { createRequestErrorMessage } from 'util/error';

//

const supplierRequestsServiceMethods = {
  componentDidUpdate,
  onCancel,
  onSubmit,
  onApproveOrRejectAllSubmit,
  onApprove,
  onApproveAll,
  onRejectAll
};

export default supplierRequestsServiceMethods;

//

function componentDidUpdate(prevProps) {
  if (prevProps.supplierRequestsTree !== this.props.supplierRequestsTree) {
    this.treeDataProvider.updateConfig({ data: this.props.supplierRequestsTree });
    this.treeDataProvider.requestData();
    this.setState({ loading: false });
  }
}

function onCancel() {
  this.setState({
    openApproveOrRejectDialog: false,
    approveSupplierRequest: false,
    approveButtonClicked: false,
    selectedSupplier: undefined,
    leadCompanyKeyValue: -1,
    comments: ''
  });
}

async function onSubmit() {
  this.setState({ loading: true });

  const grantRequestConfig = APIConfig.Sourcing.grantSupplierAccess(
    this.offeringKey,
    this.state.selectedSupplier.personKey,
    this.state.leadCompanyKeyValue,
    this.state.approveSupplierRequest,
    this.state.comments
  );

  this.setState({ approveSupplierRequest: false, selectedSupplier: undefined, leadCompanyKeyValue: -1, comments: '' });

  const isApproved = this.state.approveSupplierRequest;

  if (isApproved) {
    this.sendEvent(EVENT.SHOW_BID_TEAM_PANEL_LOADING_MASK, true);
  }

  try {
    await axios.request(grantRequestConfig);

    this.sendEvent(EVENT.REFRESH_SUPPLIER_REQUESTS);

    if (isApproved) {
      this.sendEvent(EVENT.REFRESH_BID_TEAMS);
    }
  } catch (error) {
    this.sendEvent(EVENT.DISPLAY_MASKED_APP_DIALOG, { message: createRequestErrorMessage('Error setting approval') });
    this.setState({ loading: false });
    if (isApproved) {
      this.sendEvent(EVENT.SHOW_BID_TEAM_PANEL_LOADING_MASK, false);
    }
  }
}

async function onApproveOrRejectAllSubmit(approveAction) {
  this.setState({ loading: true });

  var grantRequestConfigs = this.treeDataProvider.nodes
    .filter(node => !!node.data.personKey)
    .map(node => {
      return APIConfig.Sourcing.grantSupplierAccess(
        this.offeringKey,
        node.data.personKey,
        this.state.leadCompanyKeyValue,
        approveAction,
        this.state.comments
      );
    });

  this.setState({
    openApproveOrRejectDialog: false,
    approveButtonClicked: false,
    approveSupplierRequest: false,
    selectedSupplier: undefined,
    leadCompanyKeyValue: -1,
    comments: ''
  });
  this.sendEvent(EVENT.SHOW_BID_TEAM_PANEL_LOADING_MASK, true);

  try {
    await processInBatchesAsync(grantRequestConfigs, 5);

    this.sendEvent(EVENT.REFRESH_SUPPLIER_REQUESTS);
    this.sendEvent(EVENT.REFRESH_BID_TEAMS);
  } catch (error) {
    this.sendEvent(EVENT.DISPLAY_MASKED_APP_DIALOG, { message: createRequestErrorMessage('Error setting approval') });
    this.setState({ loading: false });
    this.sendEvent(EVENT.SHOW_BID_TEAM_PANEL_LOADING_MASK, false);
  }
}

async function processInBatchesAsync(requestConfigs, batchSize = 5) {
  const results = [];
  for (let i = 0; i < requestConfigs.length; i++) {
    const batch = requestConfigs.slice(i, i + batchSize);

    const batchPromises = batch.map(config => axios.request(config));
    const batchResults = await Promise.all(batchPromises);
    results.push(...batchResults);
  }
}

function onApprove(data) {
  const supplierBidTeam = _isSupplierInBidTeams(data.companyKey, this.props.bidTeams);
  this.setState({
    approveSupplierRequest: true,
    selectedSupplier: data,
    supplierBidTeam,
    leadCompanyKeyValue: supplierBidTeam ? supplierBidTeam.compositeKey.leadCompanyKey : -1
  });
}

function onApproveAll(data) {
  this.setState({
    openApproveOrRejectDialog: true,
    approveButtonClicked: true
  });
}

function onRejectAll(data) {
  this.setState({
    openApproveOrRejectDialog: true,
    approveButtonClicked: false
  });
}

function _isSupplierInBidTeams(selectedSupplierCompanyKey, bidTeams) {
  return bidTeams.find(bidTeam => {
    return bidTeam.bidTeamMemberKeys.includes(selectedSupplierCompanyKey);
  });
}
